/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetDealAcquiredJudgmentResult200Response } from '../models';
/**
 * DealAcquiredJudgmentResultApi - axios parameter creator
 * @export
 */
export const DealAcquiredJudgmentResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 商談獲得判断結果取得API
         * @summary 商談獲得判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAcquiredJudgmentResult: async (zoomPhoneResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoomPhoneResultId' is not null or undefined
            assertParamExists('getDealAcquiredJudgmentResult', 'zoomPhoneResultId', zoomPhoneResultId)
            const localVarPath = `/api/user/zoom_phone_results/{zoomPhoneResultId}/transcription/deal_acquired_judgment_result`
                .replace(`{${"zoomPhoneResultId"}}`, encodeURIComponent(String(zoomPhoneResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DealAcquiredJudgmentResultApi - functional programming interface
 * @export
 */
export const DealAcquiredJudgmentResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DealAcquiredJudgmentResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 商談獲得判断結果取得API
         * @summary 商談獲得判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealAcquiredJudgmentResult(zoomPhoneResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealAcquiredJudgmentResult200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealAcquiredJudgmentResult(zoomPhoneResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DealAcquiredJudgmentResultApi - factory interface
 * @export
 */
export const DealAcquiredJudgmentResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DealAcquiredJudgmentResultApiFp(configuration)
    return {
        /**
         * 商談獲得判断結果取得API
         * @summary 商談獲得判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAcquiredJudgmentResult(zoomPhoneResultId: number, options?: any): AxiosPromise<GetDealAcquiredJudgmentResult200Response> {
            return localVarFp.getDealAcquiredJudgmentResult(zoomPhoneResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DealAcquiredJudgmentResultApi - interface
 * @export
 * @interface DealAcquiredJudgmentResultApi
 */
export interface DealAcquiredJudgmentResultApiInterface {
    /**
     * 商談獲得判断結果取得API
     * @summary 商談獲得判断結果取得API
     * @param {number} zoomPhoneResultId ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealAcquiredJudgmentResultApiInterface
     */
    getDealAcquiredJudgmentResult(zoomPhoneResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetDealAcquiredJudgmentResult200Response>;

}

/**
 * Request parameters for getDealAcquiredJudgmentResult operation in DealAcquiredJudgmentResultApi.
 * @export
 * @interface DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest
 */
export interface DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResult
     */
    readonly zoomPhoneResultId: number
}

/**
 * DealAcquiredJudgmentResultApi - object-oriented interface
 * @export
 * @class DealAcquiredJudgmentResultApi
 * @extends {BaseAPI}
 */
export class DealAcquiredJudgmentResultApi extends BaseAPI implements DealAcquiredJudgmentResultApiInterface {
    /**
     * 商談獲得判断結果取得API
     * @summary 商談獲得判断結果取得API
     * @param {DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealAcquiredJudgmentResultApi
     */
    public getDealAcquiredJudgmentResult(requestParameters: DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest, options?: AxiosRequestConfig) {
        return DealAcquiredJudgmentResultApiFp(this.configuration).getDealAcquiredJudgmentResult(requestParameters.zoomPhoneResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
